import { __decorate } from "tslib";
import { Vue, Component, Mixins } from 'vue-property-decorator';
import ButtonApp from '@/components/ButtonApp.vue';
import vCLickOutside from 'v-click-outside';
import Inputmask from 'inputmask';
import { uiMapper } from '@/services/store/modules/ui/store';
import { dataMapper } from '@/services/store/modules/data/store';
const UiMappers = Vue.extend({
    methods: {
        ...uiMapper.mapMutations(['closeFormCall', 'openFormCall'])
    }
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(['formCall']),
        ...dataMapper.mapGetters(['formName', 'formPhone', 'formMail'])
    },
    methods: {
        ...dataMapper.mapMutations(['clearForm']),
        ...dataMapper.mapActions(['sendForm', 'updateFormField'])
    }
});
let FormCall = class FormCall extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.im = null;
        this.formType = 'callback';
    }
    get formCallName() { return this.formName(this.formType); }
    get formCallPhone() { return this.formPhone(this.formType); }
    get formCallMail() { return this.formMail(this.formType); }
    get name() { return this.formName(this.formType).value; }
    set name(value) { this.updateFormField({ formType: this.formType, name: 'name', 'value': value }); }
    get phone() { return this.formPhone(this.formType).value; }
    set phone(value) { this.updateFormField({ formType: this.formType, name: 'phone', 'value': value }); }
    get mail() { return this.formMail(this.formType).value; }
    set mail(value) { this.updateFormField({ formType: this.formType, name: 'mail', 'value': value }); }
    onCloseClick() {
        this.closeFormCall();
    }
    onFirstBtnClick() {
        this.$emit('firstBtnClicked');
    }
    onSecondBtnClick() {
        this.$emit('secondBtnClicked');
    }
    onClickOutside(evt) {
        const targetIsModal = evt.srcElement.classList.contains('modal-call');
        if (targetIsModal)
            this.closeFormCall();
    }
    async mounted() {
        await this.$nextTick();
        this.initPhoneMask();
    }
    beforeDestroy() {
        this.clearForm(this.formType);
    }
    // METHODS
    isInvalid(field) {
        return this.formCall.validationIsShown && field.validationRequired && !field.isValid;
    }
    initPhoneMask() {
        const selector = document.getElementById('callMePhoneInput-dss382-js');
        if (!selector)
            return;
        this.im = new Inputmask('+7(999)999-9999');
        this.im.mask(selector);
    }
    confirmForm() {
        this.sendForm(this.formType)
            .then(() => {
            this.closeFormCall();
            // @ts-ignore
            this.$router.push({ path: '/submit' }).catch(() => { });
        });
    }
};
FormCall = __decorate([
    Component({
        directives: {
            clickOutside: vCLickOutside.directive
        },
        components: {
            ButtonApp
        }
    })
], FormCall);
export default FormCall;
